<template>
    <div class="card-title">
        <div class="flex-title-text">关联情报</div>
    </div>
    <div class="card-content" v-if="similar.length">
        <div v-for="(item,index) in similar" :key="item" style="margin-bottom: 10px;line-height:1.5;">
            <!-- <a :href="item.url" target="_blank">{{ item.title }}</a> -->
            <a @click.stop="goDetail(item)"><span>{{index+1}}、</span>{{ item.title }}</a>
        </div>
    </div>
</template>
<script>
import { clickUrl } from '@/utils'

export default {
  name: "Similar",
  props: {
    similar: {
      type: Array,
      default: [],
    }
  },
  data() {
      return {
        
    };
  },
  mounted() {},
  methods: {
    goDetail(item) {
      // let query = { btnType: '0', articleId: item.id, declare_id: item.declare_id , id : item.declare_id,  }
      let query = {
        router: `/article/detail?articleId=${item.id}&declare_id=${item.declare_id}&id=${item.declare_id}&btnType='0'`
      }
      this.$router.push({ path:'/empty/index', query })
    }
  },
};
</script>
